<template>
  <form
    class="mx-auto bg-white rounded-lg shadow-xl pre-reservation form form--findyourcar"
    :class="{ 'max-w-content-xs': prereservationType === 'Dive' }"
    method="get"
    :action="bookNowUrl"
    @submit="submitForm"
  >
    <!-- Scuba Prereservation -->
    <template v-if="this.prereservationType === 'Dive'">
      <div class="flex flex-wrap items-stretch md:flex-no-wrap">
        <div class="w-1/2 md:w-1/3">
          <div class="px-4 my-4 border-r">
            <label class="flex flex-wrap mb-4 input">
              <div class="input__label">
                <div
                  class="text-xs leading-relaxed uppercase lg:text-sm font-700"
                >
                  {{ $t("reservation.pickUpDate") }}:
                </div>
              </div>

              <div class="input__field">
                <v-date-picker
                  v-model="pickupDate"
                  :popover="{ placement: 'bottom', visibility: 'click' }"
                  :min-date="MinPickupDate"
                  :locale="datePickerLocale"
                  mode="date"
                >
                  <template v-slot="{ inputEvents }">
                    <div v-on="inputEvents">
                      <div
                        v-if="!pickupDate"
                        class="pre-reservation__input-value pre-reservation__input-value--placeholder"
                      >
                        {{ FormattedInitializationPickupDate }}
                      </div>
                      <div
                        v-if="pickupDate"
                        class="pre-reservation__input-value pre-reservation__input-value--value"
                      >
                        {{ FormattedPickupDate }}
                      </div>
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </label>
          </div>
        </div>

        <div class="w-1/2 md:w-1/3">
          <div class="px-4 my-4 border-r returndate">
            <label class="flex flex-wrap mb-4 input">
              <div class="input__label">
                <div
                  class="text-xs leading-relaxed uppercase lg:text-sm font-700"
                >
                  {{ $t("reservation.returnDate") }}:
                </div>
              </div>

              <div class="input__field">
                <v-date-picker
                  v-model="returnDate"
                  :popover="{ placement: 'bottom', visibility: 'click' }"
                  :min-date="MinReturnDate"
                  :locale="datePickerLocale"
                >
                  <template v-slot="{ inputEvents }">
                    <div v-on="inputEvents">
                      <div
                        v-if="!returnDate"
                        class="pre-reservation__input-value pre-reservation__input-value--placeholder"
                      >
                        {{ FormattedInitializationReturnDate }}
                      </div>
                      <div
                        v-if="returnDate"
                        class="pre-reservation__input-value pre-reservation__input-value--value"
                      >
                        {{ FormattedReturnDate }}
                      </div>
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </label>
          </div>
        </div>

        <div class="flex-shrink-0 w-full md:w-auto">
          <div class="pt-4 md:p-4">
            <button
              class="w-full h-full text-center uppercase rounded-lg button button--brand-1"
              v-text="findYourCarButtonText"
            ></button>
          </div>
        </div>
      </div>
    </template>
    <!-- Car and Scooter Prereservation -->
    <template v-else>
      <div class="flex flex-wrap items-stretch md:flex-no-wrap">
        <div class="w-1/2 md:w-1/5">
          <div class="px-4 my-4 border-r">
            <label class="flex flex-wrap mb-4 input">
              <div class="input__label">
                <div
                  class="text-xs leading-relaxed uppercase lg:text-sm font-700"
                >
                  {{ $t("reservation.pickUpDate") }}:
                </div>
              </div>
              <div class="input__field">
                <v-date-picker
                  v-model="pickupDate"
                  :popover="{ placement: 'bottom', visibility: 'click' }"
                  :min-date="MinPickupDate"
                  :locale="datePickerLocale"
                  mode="date"
                >
                  <template v-slot="{ inputEvents }">
                    <div v-on="inputEvents">
                      <div
                        v-if="!pickupDate"
                        class="pre-reservation__input-value pre-reservation__input-value--placeholder"
                      >
                        {{ FormattedInitializationPickupDate }}
                      </div>
                      <div
                        v-if="pickupDate"
                        class="pre-reservation__input-value pre-reservation__input-value--value"
                      >
                        {{ FormattedPickupDate }}
                      </div>
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </label>
          </div>
        </div>
        <div class="w-1/2 md:w-1/5">
          <div class="px-4 my-4 md:border-r pickuptime">
            <label class="flex flex-wrap mb-4 input">
              <div class="input__label">
                <div
                  class="text-xs leading-relaxed uppercase lg:text-sm font-700"
                >
                  {{ $t("reservation.pickUpTime") }}:
                </div>
              </div>

              <div class="input__field input__field--time">
                <input
                  type="time"
                  placeholder="12:00"
                  class="time-input__touch"
                  v-model="pickupTime"
                />
                <flat-pickr
                  id="pickupTime"
                  :placeholder="placeHolderPickupTime"
                  v-model="pickupTime"
                  :config="flatPickrConfigTime"
                  class="flatpickr time-input__no-touch"
                ></flat-pickr>
              </div>
            </label>
          </div>
        </div>
        <div class="w-1/2 md:w-1/5">
          <div class="px-4 my-4 border-r returndate">
            <label class="flex flex-wrap mb-4 input">
              <div class="input__label">
                <div
                  class="text-xs leading-relaxed uppercase lg:text-sm font-700"
                >
                  {{ $t("reservation.returnDate") }}:
                </div>
              </div>

              <div class="input__field">
                <v-date-picker
                  v-model="returnDate"
                  :popover="{ placement: 'bottom', visibility: 'click' }"
                  :min-date="MinReturnDate"
                  :locale="datePickerLocale"
                >
                  <template v-slot="{ inputEvents }">
                    <div v-on="inputEvents">
                      <div
                        v-if="!returnDate"
                        class="pre-reservation__input-value pre-reservation__input-value--placeholder"
                      >
                        {{ FormattedInitializationReturnDate }}
                      </div>
                      <div
                        v-if="returnDate"
                        class="pre-reservation__input-value pre-reservation__input-value--value"
                      >
                        {{ FormattedReturnDate }}
                      </div>
                    </div>
                  </template>
                </v-date-picker>
              </div>
            </label>
          </div>
        </div>
        <div class="w-1/2 md:w-1/5">
          <div class="px-4 my-4 md:border-r returntime">
            <label class="flex flex-wrap mb-4 input">
              <div class="input__label">
                <div
                  class="text-xs leading-relaxed uppercase lg:text-sm font-700"
                >
                  {{ $t("reservation.returnTime") }}:
                </div>
              </div>

              <div class="input__field input__field--time">
                <input
                  type="time"
                  :placeholder="placeHolderReturnTime"
                  class="time-input__touch"
                  v-model="returnTime"
                />
                <flat-pickr
                  d="returnTime"
                  :placeholder="placeHolderReturnTime"
                  v-model="returnTime"
                  :config="flatPickrConfigTime"
                  class="flatpickr time-input__no-touch"
                ></flat-pickr>
              </div>
            </label>
          </div>
        </div>
        <div class="flex-shrink-0 w-full md:w-auto">
          <div class="pt-4 md:p-4">
            <button
              class="w-full h-full text-center uppercase rounded-lg button button--brand-1"
              v-text="findYourCarButtonText"
            ></button>
          </div>
        </div>
      </div>
    </template>
  </form>
</template>

<script>
/* global preReservationConfiguration */

import Vue from "vue";
import { mapGetters } from "vuex";
import CaagApi from "@/mixins/CaagApi";
import DateTimeHelper from "@/mixins/DateTimeHelper";
import ReservationHelper from "@/mixins/ReservationHelper";
import VCalendar from "v-calendar";
import store from "../store";

import flatPickr from "vue-flatpickr-component";
import { flatPickrEnglish } from "flatpickr/dist/l10n/default.js";
import { flatPickrDutch } from "flatpickr/dist/l10n/nl.js";
import { flatPickrGerman } from "flatpickr/dist/l10n/de.js";
switch (document.querySelector("html").attributes["lang"].value) {
  case "nl-NL":
    flatpickr.localize(flatPickrDutch);
    break;
  case "de":
    flatpickr.localize(flatPickrGerman);
    break;
  default:
    flatpickr.localize(flatPickrEnglish);
    break;
}

// Use v-calendar & v-date-picker components
Vue.use(VCalendar);

export default {
  components: { flatPickr },
  mixins: [CaagApi, DateTimeHelper, ReservationHelper],
  data: function () {
    return {
      bookNowUrl: null,
      season: null,
      pickupDate: null,
      pickupTime: null,
      returnDate: null,
      returnTime: null,
      timeFormat: null,
      placeHolderPickupTime: "12:00 PM",
      placeHolderReturnTime: "12:00 PM",
      datePickerLocale: "en",
      flatPickrConfigTime: {
        altFormat: "G:i K",
        altInput: true,
        dateFormat: "H:i",
        enableTime: true,
        noCalendar: true,
        minuteIncrement: 15,
        disableMobile: true,
        time_24hr: false,
      },
    };
  },
  mounted() {
    this.$store.dispatch("setPrereservationType");
    this.initializeDateTimePicker();
  },
  computed: {
    ...mapGetters(["prereservationType"]),
    findYourCarButtonText() {
      if (this.prereservationType == "Scooter") {
        return this.$t("reservation.findYourScooter");
      }
      if (this.prereservationType == "Dive") {
        return this.$t("reservation.findYourScubaSuit");
      }
      if (this.prereservationType == "Eco Wheels") {
        return this.$t("reservation.findYourEcoWheels");
      }
      return this.$t("reservation.findYourCar");
    },
    FormattedPickupDate: function () {
      return this.getFormattedShortDateWithoutYear(this.pickupDate);
    },
    FormattedReturnDate: function () {
      return this.getFormattedShortDateWithoutYear(this.returnDate);
    },
    MinPickupDate: function () {
      return this.minReservationDate();
    },
    MinReturnDate: function () {
      let minimalRentalDays = 1;
      if (this.season && this.season.minimal_rental_period) {
        minimalRentalDays = this.season.minimal_rental_period;
      }
      return this.minReservationReturnDate(
        this.pickupDate ? this.pickupDate : this.MinPickupDate,
        minimalRentalDays
      );
    },
    FormattedInitializationPickupDate: function () {
      return this.getFormattedShortDateWithoutYear(this.MinPickupDate);
    },
    FormattedInitializationReturnDate: function () {
      return this.getFormattedShortDateWithoutYear(this.MinReturnDate);
    },
  },
  watch: {
    pickupDate(val) {
      if (this.pickupTime) {
        this.getSeasons(this.getDateTimeAPIFormat(val, this.pickupTime));
      } else {
        this.getSeasons(this.getDateTimeAPIFormat(val, "12:00"));
      }
      this.checkReturnTime();
    },
    pickupTime(val) {
      if (this.pickupDate) {
        this.getSeasons(this.getDateTimeAPIFormat(this.pickupDate, val));
      }
    },
  },
  methods: {
    initializeDateTimePicker() {
      switch (document.querySelector("html").attributes["lang"].value) {
        case "nl-NL":
          this.placeHolderPickupTime = "12:00";
          this.placeHolderReturnTime = "12:00";
          this.flatPickrConfigTime.altFormat = "H:i";
          this.flatPickrConfigTime.time_24hr = true;
          this.datePickerLocale = "nl";
          this.bookNowUrl = "/boek-nu/";
          break;
        case "de":
          this.placeHolderPickupTime = "12:00";
          this.placeHolderReturnTime = "12:00";
          this.flatPickrConfigTime.altFormat = "H:i";
          this.flatPickrConfigTime.time_24hr = true;
          this.datePickerLocale = "de";
          this.bookNowUrl = "/book-now/";
          break;
        default:
          this.placeHolderPickupTime = "12:00 PM";
          this.placeHolderReturnTime = "12:00 PM";
          this.flatPickrConfigTime.altFormat = "G:i K";
          this.flatPickrConfigTime.time_24hr = false;
          this.datePickerLocale = "en";
          this.bookNowUrl = "/book-now/";
          break;
      }

      if (window.preReservationConfiguration) {
        if (window.preReservationConfiguration.bookNowUrl !== "") {
          this.bookNowUrl = window.preReservationConfiguration.bookNowUrl;
        }
      }
      this.getSeasons(this.getDateTimeAPIFormat(this.MinPickupDate, "12:00"));
    },
    checkReturnTime() {
      if (this.returnDate) {
        if (this.MinReturnDate > this.returnDate) {
          this.returnDate = this.MinReturnDate;
        }
      }
    },
    submitForm() {
      store.commit("reset");

      store.commit("setType"); //SetType to prevent <template v-if="this.prereservationType === 'Dive'"> rerendering to <template v-else>
      store.commit("setPrereservationType"); //setPrereservationType to prevent <template v-if="this.prereservationType === 'Dive'"> rerendering to <template v-else>

      if (this.pickupDate) {
        store.commit("setPickupDate", this.pickupDate);
      } else {
        store.commit("setPickupDate", this.getDateFormat(this.MinPickupDate));
      }
      if (this.pickupTime) {
        store.commit("setPickupTime", this.pickupTime);
      } else {
        store.commit("setPickupTime", "12:00");
      }
      if (this.returnDate) {
        store.commit("setReturnDate", this.returnDate);
      } else {
        store.commit("setReturnDate", this.getDateFormat(this.MinReturnDate));
      }
      if (this.returnTime) {
        store.commit("setReturnTime", this.returnTime);
      } else {
        store.commit("setReturnTime", "12:00");
      }
    },
    // getFindYourCarText(){
    //     console.log(this.prereservationType)
    //     if(this.prereservationType == 'Scooter') {
    //         return this.$t("reservation.findYourScooter")
    //     }
    //     if(this.prereservationType == 'Dive') {
    //         return this.$t("reservation.findYourScubaSuit")
    //     }
    //     return this.$t("reservation.findYourCar")
    // },
  },
};
</script>

<style scoped lang="scss">
.max-w-content-xs {
  max-width: 720px;
}
</style>
